"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answersViewModel = answersViewModel;
const answer_1 = require("./answer");
function answersViewModel(answers, setAnswer, clearAnswers) {
    return {
        answers: answers.map((answer) => (0, answer_1.answerViewModel)(answer, setAnswer)),
        setAnswer,
        clearAnswers,
    };
}
